// StarRating.tsx
import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import styles from "./StarRating.module.css";

interface StarRatingProps {
  rating: number;
  interactive?: boolean;
  onChange?: (rating: number) => void;
  variant?: 'large' | 'medium' | 'small';
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  interactive = false,
  onChange,
  variant = 'medium',
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (index: number) => {
    if (interactive) {
      setHoverRating(index + 1);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(0);
    }
  };

  const handleClick = (index: number) => {
    if (interactive && onChange) {
      onChange(index + 1);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className={`${styles.starRating} ${styles[`starRating_${variant}`]}`}>
      {[...Array(5)].map((_, index) => {
        const fillPercentage = Math.min(
          Math.max((displayRating - index) * 100, 0),
          100
        );

        return (
          <div
            key={index}
            className={`${styles.starContainer} ${
              interactive ? styles.interactive : ""
            }`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(index)}
          >
            <FaStar className={styles.star} />
            <div
              className={styles.starFillContainer}
              style={{ width: `${fillPercentage}%` }}
            >
              <FaStar className={styles.starFilled} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
